import React from 'react';
import cx from 'classnames';
import {DropdownV2, Title, Text} from '@priority-software/priority-style-react';
import styles from '../styles/PersonalizationCenter.module.scss';
import texts from '../texts';
import {getTopDialogZindex} from '../../../_shared/GWTBridge/invoke/priModalDlg';
import {SnoozedSuggestion, SuggestionType} from '../types/personalizationCenter';

type CenterDropdownProps = {
    items: SnoozedSuggestion[];
    renderSnoozedSuggestions: (suggestionType: string) => void;
    closeDropdown: () => void;
};

const getitemText = (item: SnoozedSuggestion): string => {
    switch (item.type) {
        case SuggestionType.Actions:
            return texts.switchActions;
        case SuggestionType.Searches:
            return texts.saveTopSearch;
        case SuggestionType.Subforms:
            return texts.hideSubForms;
        default:
            return '';
    }
};

export const CenterDropdown = ({
    items,
    renderSnoozedSuggestions,
    closeDropdown
}: CenterDropdownProps) => {
    return (
        <DropdownV2
            isOpen
            openingSide={'leftSide'}
            style={{zIndex: getTopDialogZindex()}}
            contentComponentClasses={styles.dropdownContainer}
            onClose={closeDropdown}
        >
            <Title
                skin="h6"
                textColor="primary-500"
                text={texts.upperTitle}
                componentClasses={styles.menuTitle}
            />
            {items.map((item, index) => {
                const text = getitemText(item);
                const notLast = index < items.length - 1;
                return (
                    text && (
                        <Text
                            key={item.type}
                            skin="paragraph-2"
                            textColor="primary-700"
                            componentClasses={cx(styles.menuItem, {
                                [styles.borderBottom]: notLast
                            })}
                            onClick={() => renderSnoozedSuggestions(item.type)}
                        >
                            {text}
                        </Text>
                    )
                );
            })}
        </DropdownV2>
    );
};
